import { Close } from "@mui/icons-material";
import { Box, DialogTitle, IconButton } from "@mui/material";

interface IDialogHeaderProps {
  title: string;
  showCloseButton?: boolean;
  onClose?: () => void;
}

const DialogHeader = ({
  title,
  showCloseButton,
  onClose,
}: IDialogHeaderProps) => {
  return (
    <Box
      sx={(theme) => ({
        position: "relative",
        p: 2,
        textAlign: "center",
        background:
          theme.palette.mode === "dark"
            ? theme.palette.primary.light
            : theme.palette.primary.lighter,
      })}
    >
      {showCloseButton && (
        <IconButton
          onClick={onClose}
          size="small"
          sx={{
            position: "absolute",
            right: 8,
            top: "16px",
            color: "grey.500",
            "&:hover": {
              backgroundColor: "rgba(0,0,0,0.04)",
            },
          }}
        >
          <Close fontSize="small" />
        </IconButton>
      )}

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 1,
        }}
      >
        <DialogTitle
          sx={{
            p: 0,
            fontSize: "20px",
            fontWeight: 600,
            color: "text.primary",
          }}
        >
          {title}
        </DialogTitle>
      </Box>
    </Box>
  );
};
export default DialogHeader;
